import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import {
  CreateOrUpdateSupplierMaterialInput,
  CreateOrUpdateSupplierMaterialMutation,
} from '@/gql/graphql';

const CREATE_OR_UPDATE_SUPPLIER_MATERIAL = graphql(`
  mutation CreateOrUpdateSupplierMaterial(
    $input: CreateOrUpdateSupplierMaterialInput!
  ) {
    createOrUpdateSupplierMaterial(input: $input) {
      id
    }
  }
`);

const useCreateOrUpdateSupplierMaterial = (
  options?: UseMutationOptions<
    CreateOrUpdateSupplierMaterialMutation,
    unknown,
    CreateOrUpdateSupplierMaterialInput
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(CREATE_OR_UPDATE_SUPPLIER_MATERIAL, { input });
    },
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries({
        predicate: (query) => {
          return (
            query.queryKey[0] === 'project' &&
            (query.queryKey[2] === 'materialsList' ||
              query.queryKey[2] === 'profitBreakdown')
          );
        },
      });
      options?.onSuccess?.(data, variables, context);
    },
    ...options,
  });
};

export default useCreateOrUpdateSupplierMaterial;
